import {Trans, useTranslation} from "react-i18next";
import Modal from 'react-modal';
import React, {useState} from "react";
import CheckBoxRefinementList from "../CheckBoxRefinementList";
import algoliasearch from "algoliasearch/lite";
import qs from "qs";
import {InstantSearch, Configure} from "react-instantsearch-dom";
import PartnerResultPanel from "./PartnerResultPanel";
import SearchInput from "../DirectoryPanel/SearchInput";
import CurrentRefinementList from "../DirectoryPanel/CurrentRefinementList";
import FilterPanel from "../DirectoryPanel/FilterPanel";
import ResultsPanel from "../DirectoryPanel/ResultsPanel";
import DirectoryPagination from "../DirectoryPanel/DirectoryPagination";
import FavoriteItem from "../DirectoryPanel/FavoriteItem";
import PartnerMessagePanel from "./PartnerMessagePanel";
import PartnerFilterPanel from "./PartnerFilterPanel";

const searchClient = algoliasearch(
    "6KMP52GB5X",
    "a4bb5f7de85b6dc3b2313ece00f93394"
);
const createURL = (state) => `?${qs.stringify(state)}`;
const DEBOUNCE_TIME = 700;
const DIRECTORY_INDEX = window.directory_index

const customStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
    },
};

const modalSizeStyles = {
    content: {
        position: 'absolute',
        inset: '10%',
        background: 'none',
        border: 'none',
        overflow: 'initial',
        outline: 'none',
        padding: '0px',
        marginTop: '15px',
    },
};

const modalMessageSizeStyles = {
    content: {
        position: 'absolute',
        inset: '10%',
        border: '1px solid rgb(204, 204, 204)',
        background: 'rgb(255, 255, 255)',
        overflow: 'initial',
        borderRadius: '4px',
        outline: 'none',
        padding: '0px',
        marginTop: '15px',
    },
};

export default function PartnerContactPanel(props) {
    const {t, i18n} = useTranslation();
    const [modalIsOpen, setIsOpen] = useState(false);
    const [messageIsOpen, setMessageIsOpen] = useState(false);

    let subtitle;

    let openModal = () => {
        //setIsOpen(true);
        window.location.href='/building-material-contact';
    }

    let afterOpenModal = () => {
        subtitle.style.color = '#f00';
    }

    let closeModal = () => {
        setIsOpen(false);
    }

    let getModalStyle = () => {
        if (messageIsOpen) {
            return modalMessageSizeStyles;
        } else {
            return modalSizeStyles;
        }
    }

    return (
        <InstantSearch
            searchClient={searchClient}
            indexName={DIRECTORY_INDEX}
            initialUiState={{
                DIRECTORY_INDEX: {
                    facetFilters: [
                        [
                            "directory_user_type:Manufacturers+Suppliers"
                        ]
                    ],
                },
            }}
        >
            <Configure
                analytics={true}
                filters={'directory_user_type:"Manufacturers Suppliers"'}
                hitsPerPage={40}
            />
            <div>
                <div className="partner-modal-btn" style={{marginBottom:'-20px'}}>
                    <a href="/building-material-contact" target='_blank' className="btn btn--outline" style={{margin:'auto'}}>Contact Manufacturers & Suppliers</a>
                </div>
                <Modal
                    id="modal_with_forms"
                    style={getModalStyle()}
                    isOpen={modalIsOpen}
                    closeTimeoutMS={150}
                    contentLabel="modalB"
                    shouldCloseOnOverlayClick={false}
                    onRequestClose={closeModal}
                    aria={{
                        labelledby: "heading",
                        describedby: "fulldescription"
                    }}>
                    <button onClick={closeModal}
                            className="form__btn-filters partners-form-close section__btn-filter js-btn-filter">Cancel
                    </button>
                    {messageIsOpen ?
                        <PartnerMessagePanel onMessageCancel={() => setMessageIsOpen(false)} onMessageSend={() => setIsOpen(false) }/>
                        :
                        <PartnerFilterPanel onMessageShow={() => setMessageIsOpen(true)}/>
                    }


                </Modal>
            </div>
        </InstantSearch>
    )
}
